import React, { useEffect, useRef, useState } from "react";
 import { Link, useNavigate } from "react-router-dom";
import {API_URL} from "../utils/api";
import axios  from "axios";
import { ToastContainer, toast } from 'react-toastify';
import { Routes, Route, useParams } from 'react-router-dom';
import he from 'he';

const ViewServiceLayer = () => {
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState(null);
  let { id } = useParams();

console.log(id);
 
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
 async function fetchServiceInfo(){

  axios.get(process.env.REACT_APP_API_BASE_URL+"service-details/"+id)
      .then((res) => {
          // return false;
        if(res.data){
          console.log('red data',res.data);
      let baseurl = API_URL.replace("api", "");
            setTitle(res.data.title);
             setCategory(res.data.category);
             setDescription(res.data.content);
              setImagePreview(baseurl+res.data.image);

        }
        else{
          toast.success("something went wrong...")
        }
      })
      .catch(err => {
        console.error(err);
        alert(err);
      });
}
  useEffect(() => {
     fetchServiceInfo();
  }, []);
  function renderHTML  (escapedHTML) {
   return  React.createElement("div", { dangerouslySetInnerHTML: { __html: escapedHTML } });
  }

  return (
    <div className='row gy-4'>
      <div className='col-lg-12'>
        <div className='card mt-24'>
          <div className='card-header border-bottom'>
            <h6 className='text-xl mb-0'>Service Details</h6>
          </div>
           <div className='card-body p-24'>
            
              <div>
                <label
                  className='form-label fw-bold text-neutral-900'
                  htmlFor='title'
                >
                  Post Title:{" "}
                </label>
                 {title} 
              </div>
              <div>
                <label className='form-label fw-bold text-neutral-900'>
                  Post Category:{" "}
                </label>
                {category} 
              </div>
              <div>
                <label className='form-label fw-bold text-neutral-900'>
                  Image Thumbnail
                </label>
                <div className='upload-image-wrapper'>
                  {imagePreview ? (
                     
                      <img
                        id='uploaded-img__preview'
                        className='w-50'
                        src={imagePreview}
                        alt='Uploaded'
                      />
                    
                  ) : ''}
                </div>
                </div>
              <div>
                <label className='form-label fw-bold text-neutral-900'>
                  Post Description
                </label>
                <div  >
                     {renderHTML(description)} 
                  </div>
                </div>
              </div>
             
              </div> 
          </div>
        </div>
       
  );
};

export default ViewServiceLayer;
